import React from 'react';
import Svg, { Path } from 'react-native-svg';

interface DotsVerticalFilledIconProps {
  size?: number;
  color?: string;
}

export function DotsVerticalFilledIcon({ size = 20, color = '#161616' }: DotsVerticalFilledIconProps) {
  return (
    <Svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <Path
        d="M11.67 10C11.67 10.44 11.49 10.87 11.18 11.18C10.87 11.49 10.44 11.67 10 11.67C9.56 11.67 9.13 11.49 8.82 11.18C8.51 10.87 8.33 10.44 8.33 10C8.33 9.97 8.33 9.94 8.34 9.91C8.36 9.49 8.54 9.09 8.85 8.79C9.16 8.5 9.57 8.33 10 8.33C10.44 8.33 10.87 8.51 11.18 8.82C11.49 9.13 11.67 9.56 11.67 10ZM11.67 15.83C11.67 16.27 11.49 16.7 11.18 17.01C10.87 17.32 10.44 17.5 10 17.5C9.56 17.5 9.13 17.32 8.82 17.01C8.51 16.7 8.33 16.27 8.33 15.83C8.33 15.8 8.33 15.78 8.34 15.75C8.36 15.32 8.54 14.92 8.85 14.62C9.16 14.33 9.57 14.17 10 14.17C10.44 14.17 10.87 14.34 11.18 14.65C11.49 14.97 11.67 15.39 11.67 15.83ZM11.67 4.17C11.67 4.61 11.49 5.03 11.18 5.34C10.87 5.66 10.44 5.83 10 5.83C9.56 5.83 9.13 5.66 8.82 5.34C8.51 5.03 8.33 4.61 8.33 4.17C8.33 4.14 8.33 4.11 8.34 4.08C8.36 3.65 8.54 3.25 8.85 2.96C9.16 2.66 9.57 2.5 10 2.5C10.44 2.5 10.87 2.68 11.18 2.99C11.49 3.3 11.67 3.72 11.67 4.17Z"
        fill={color}
      />
    </Svg>
  );
}
